<template>

</template>

<script>
export default {
  name: "ResetPassword"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sign/ResetPassword.vue